import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { toastr } from 'react-redux-toastr';
import { Field, reduxForm, FieldArray } from 'redux-form';
import {
    renderSelectField,
    renderEmailInputField,
    renderTextInputField,
    renderPasswordInputField, renderRadioInputField, CheckboxGroup, renderStoryItems
} from '../Layout/FormInputs';
import { langs } from "../../config/localization";
import {
    getAuthToken,
    getUserId
} from "../../actions/Common";
import { Loader } from "../Common/Loader";

const cities = [
    {
        id: "Los Altos",
        text: "Los Altos"
    },
    {
        id: "Newyork",
        text: "Newyork"
    }
];

import {
  editProfile,
  getProfileDetailsLocalStorage,
  changePassword,
  updateProfilePic,
  getUserProfileDetails
} from "../../actions/UserAction";
import {API_URL, APP_URL, DEFAULT_USER_IMAGE} from "../../config/config";
import {required} from "../../validation";

class ChangePassword extends Component {
    /**
     * Class constructor
     * @param props
     */
    constructor(props) {
        super(props);

        //Keep values in state
        this.state = {
            showLoader: false,
        };
    }

    /**
     * Submit the login form
     * @param values
     */
    onSubmit(values){
        this.setState({showLoader : true});
        //Call the edit profile action
        this.props.editProfile(values, getUserId(), (response) => {
            if (response != undefined) {
                this.setState({ showLoader: false });

                if (response.status == 200) {
                    toastr.success(langs.success, langs.messages.profile_update_success);
                } else if (response.status == 401) {
                    toastr.error(langs.error, langs.messages.unauthenticated_user);
                } else if (response.status == 404) {
                    toastr.error(langs.error, langs.messages.resource_not_found);
                } else {
                    toastr.error(langs.error, langs.messages.default_error);
                }
            }
        });
    }

    render(){
        const {handleSubmit} = this.props;

        if(!this.state.showLoader) {
            return (
                <div>
                <section className="change-password">
                    <div className="row">
                        <div className="medium-12 columns">
                            <div className="breadcumb">
                                <a href="/dashboard" className="breadcumb-underline">My earthDECK </a> > <a href="edit-profile" className="active breadcumb-underline">Edit Profile</a> > <a href="change-password" className="active">Change Password</a>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="medium-12 columns">
                            <h1 className="page-heading text-center">Change Password</h1>
                        </div>
                    </div>
                    <form noValidate className="form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                  
                      <div className="row login-form">                       
                            <div className="shadow-box clearfix m-t20 m-b50">
                                <div className="medium-6 columns">
                                    <div className="form-group clearfix">
                                    <label>New Password*</label>
                                        <Field
                                            name="password"
                                            component={renderPasswordInputField}
                                        />
                                    </div>
                                </div>
                                <div className="medium-6 columns">
                                    <div className="form-group clearfix">
                                    <label>Confirm Password*</label>
                                    <Field
                                        name="newPassword"
                                        component={renderPasswordInputField}
                                    />
                                    </div>
                                </div>
                                <div className="clearfix"></div>
                                <div className="medium-12 columns">
                                    <div className="form-group text-center m-t20">
                                        <button type="submit" className="btn-primary primary-gradient-bg">
                                            <span>SAVE</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>                    
                    </form>
                </section>
                </div>
            );
        } else {
            return <Loader loaderContent='form-submission' />
        }
    }
}

/**
 * Form validation
 * @param values
 * @returns {{}}
 */
function validate(values) {
    let errors = {};

    if(!values.password){
        errors.password = langs.validation_messages.password_required;
    }

    if(values.password && (values.password.length < 4 || values.password.length > 32 )){
        errors.password = langs.validation_messages.password_length;
    }

    if(!values.newPassword){
        errors.newPassword = langs.validation_messages.confirm_password_required;
    }

    if(values.password != values.newPassword){
        errors.newPassword = langs.validation_messages.password_confirm_password;
    }
    return errors;
}

const mapStateToProps = ({ user }) => {
  const { authUserDetails } = user;
  let returnObj = {};

  //Keep values in initial values object to be passed on form submit
    returnObj.authUserDetails = authUserDetails;
    if(authUserDetails){
        returnObj.initialValues  = {
            name: authUserDetails.name,
            email: authUserDetails.email,
            location: authUserDetails.location,
            profile: authUserDetails.profile,

        };
    }

    return returnObj;
};

export default connect(mapStateToProps, {editProfile, getProfileDetailsLocalStorage, getUserProfileDetails})(reduxForm({
    form: 'ChangePasswordForm',
    validate,
    enableReinitialize: true
})(ChangePassword));



// WEBPACK FOOTER //
// ./components/User/ChangePassword.js